import { ProductionRoutePeriodCoverage } from '@/hooks/api/v2/productionRoutes'
import useI18n from '@/shared/hooks/useI18n'
import cx from 'classnames'

const periodCoverageBaseClass = [
  'rounded',
  'text-center',
  'px-3.5',
  'font-semibold',
  'py-2.5',
  'text-sm',
  'border-2',
  'border-dashed'
].join(' ')

const reporingEnabledClass = 'border-green-600'
const reportingDisabledClass = 'bg-gray-[#F5F6F6] text-gray-600 border-gray-[#F5F6F6]'
const reportDraftClass = 'bg-yellow-300 border-yellow-500 border-dashed '
const reportSubmittedClass = 'bg-green-300 border border-green-600'

export default function PeriodCoverageStatusBadge({
  reportingPeriodBasis,
  periodCoverage,
  onMouseEnter,
  onMouseLeave
}: {
  reportingPeriodBasis: string
  periodCoverage: ProductionRoutePeriodCoverage
  onMouseEnter: () => void
  onMouseLeave: () => void
}) {
  const { dateLongFormatterMonth, dateLongFormatterMonthYear } = useI18n()
  const [year, month] = periodCoverage.month.split('-')
  const date = new Date(parseInt(year), parseInt(month) - 1)
  const label =
    reportingPeriodBasis === 'CALENDAR_YEAR'
      ? dateLongFormatterMonth(date)
      : dateLongFormatterMonthYear(date)

  if (!periodCoverage.reportingEnabled) {
    return <div className={cx(periodCoverageBaseClass, reportingDisabledClass)}>{label}</div>
  }

  if (periodCoverage.reportSubmitted) {
    return (
      <div
        className={cx(periodCoverageBaseClass, reportSubmittedClass)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {label}
      </div>
    )
  }

  if (periodCoverage.reportDraft) {
    return (
      <div
        className={cx(periodCoverageBaseClass, reportDraftClass)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {label}
      </div>
    )
  }

  return (
    <div
      className={cx(periodCoverageBaseClass, reporingEnabledClass)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {label}
    </div>
  )
}
